import { render, staticRenderFns } from "./MemberLabelCardPane.vue?vue&type=template&id=2ff93f86&scoped=true"
import script from "./MemberLabelCardPane.vue?vue&type=script&lang=js"
export * from "./MemberLabelCardPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff93f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff93f86')) {
      api.createRecord('2ff93f86', component.options)
    } else {
      api.reload('2ff93f86', component.options)
    }
    module.hot.accept("./MemberLabelCardPane.vue?vue&type=template&id=2ff93f86&scoped=true", function () {
      api.rerender('2ff93f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/member_label/MemberLabelCardPane.vue"
export default component.exports